import { mergeStyles } from '@cian/utils/lib/shared/style';

import * as React from 'react';

import { IOtherLinksSchema } from '../../repositories/header/entities/other_links/OtherLinksSchema';

import { LeadRealtorBanner } from '../LeadRealtorBanner';
import { PikIcon } from '../PikIcon';

import { CloseIcon, ICONS } from './icons';
import { TDropdownType } from './interfaces';
import { TagNew } from './internal/components';
import { trackDropdownLinkClick } from './tracking';

export interface IDropdownMenuLink {
  analyticsEvent?: string;
  analyticsLabel?: string;
  children?: IDropdownMenuLink[];
  className?: string;
  icon?: string;
  image?: string;
  isBold?: boolean;
  isCountrysidePromoLink?: boolean;
  isDomrfLink?: boolean;
  isNew?: boolean;
  isTitle?: boolean;
  key?: string;
  target?: string;
  text?: JSX.Element | string;
  url?: string | null;
}

export interface IDropdownMenuProps {
  hasShadow?: boolean;
  links: IDropdownMenuLink[];
  name: TDropdownType;
  otherLinks: IOtherLinksSchema;
  catalogDevelopersUrl?: string;
  isOpen?: boolean;
  onClose?(): void;
  onMouseLeave?(key: string): void;
  styleHoverPanel?: { [key: string]: string };
}

export interface IDropdownMenuState {
  dropdownOver?: boolean;
  initialized?: boolean;
  mouseInTriangle?: boolean;
  parentOver?: boolean;
}

const styles = require('./dropdown_menu.css');

export class DropdownMenu extends React.Component<IDropdownMenuProps, IDropdownMenuState> {
  public constructor(props: IDropdownMenuProps) {
    super(props);

    this.state = {
      parentOver: false,
    };
  }

  public componentDidMount() {
    this.setState({ initialized: true });
  }

  public render() {
    const { links } = this.props;

    if (!Array.isArray(links) || !links.length) {
      return <div />;
    }

    return (
      <div
        {...mergeStyles(
          styles['container'],
          this.state.initialized && styles['container--initialized'],
          this.props.hasShadow && styles['container--has_shadow'],
          styles['container--scale'],
          this.props.isOpen && styles['container--scale_over'],
          'c-header-bottom-menu-item-dropdown',
        )}
      >
        <div className="c-header-container c-header-container-border">
          <div className="c-header-dropdown-close-icon" onClick={this.props.onClose}>
            <CloseIcon />
          </div>
          <div className="c-header-container-row">{this.renderLinks()}</div>
        </div>
      </div>
    );
  }

  private renderLinks() {
    const { name, links, otherLinks, catalogDevelopersUrl, isOpen } = this.props;

    const isSearchMap = name === 'rent' || name === 'sale' || name === 'newbuildings' || name === 'commercial';

    return (
      <div className="c-header-col c-header-left-container-skip">
        <div className={styles['list']}>
          <div className={styles['links-grid']}>
            <div className={styles['row-container']}>
              {links.map((group, groupIndex) => (
                <div key={`group-${groupIndex}`} className={styles['cell']}>
                  {group.children &&
                    group.children.map((link, linkIndex) => {
                      const cssClassLink = link.isBold || link.isTitle ? 'cell-link-title' : 'cell-link';
                      const key = `group-${groupIndex}-link-${linkIndex}`;
                      const extraLinkClass = link.className || '';

                      if (link.url) {
                        return (
                          <a
                            key={key}
                            {...mergeStyles(styles[cssClassLink], styles[extraLinkClass])}
                            href={link.url}
                            onClick={this.onLinkClick(link)}
                          >
                            {link.icon && <span className={styles['cell-link-icon']}>{ICONS[link.icon]}</span>}
                            {link.key === 'pik' && <PikIcon className={styles['cell-link-icon']} />}
                            {link.image && (
                              <span
                                className={styles['cell-link-icon']}
                                style={{
                                  backgroundImage: `url(${link.image})`,
                                }}
                              />
                            )}
                            {link.text}
                            {link.isNew && <TagNew containerClassName={styles['tag-new']} />}
                          </a>
                        );
                      }

                      if (link.isTitle) {
                        return (
                          <div key={key} className={styles[cssClassLink]}>
                            {link.icon && <span className={styles['cell-link-icon']}>{ICONS[link.icon]}</span>}
                            {link.text}
                          </div>
                        );
                      }

                      return null;
                    })}
                </div>
              ))}
              {links.length < 3 && (
                <div className={styles['cell']}>
                  <LeadRealtorBanner url={otherLinks.leadRealtorForm} isShown={isOpen} />
                </div>
              )}
            </div>
            <ul className={styles['horizontal-bottom-menu']}>
              <li className="another-change-location" />
              {isSearchMap && (
                <li>
                  <a href={otherLinks.map} className={styles['horizontal-link']}>
                    Поиск по карте
                  </a>
                </li>
              )}
              <li>
                <a href={otherLinks.helpCenter} className={styles['horizontal-link']}>
                  Справочный центр
                </a>
              </li>
              <li>
                <a href={catalogDevelopersUrl} className={styles['horizontal-link']}>
                  Каталог застройщиков
                </a>
              </li>
              <li>
                <a href={otherLinks.realtorsForum} className={styles['horizontal-link']}>
                  Вопросы риэлтору
                </a>
              </li>
              <li>
                <a href={otherLinks.cianCareer} className={styles['horizontal-link--accent']}>
                  Карьера в Циан
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  private onLinkClick = ({
    analyticsEvent,
    analyticsLabel,
    url,
    target,
  }: {
    url?: string | null;
    target?: string;
    analyticsEvent?: string;
    analyticsLabel?: string;
  }) => (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    if (analyticsLabel) {
      trackDropdownLinkClick(analyticsLabel, analyticsEvent);
    }

    if (url) {
      // eslint-disable-next-line no-unused-expressions
      target === '_blank' ? window.open(url) : location.assign(url);
    }
  };
}
